import Marquee from "react-fast-marquee";

const items = [
  "You Write",
  "She Evaluates",
  "Weekly Report Cards",
  "0.5 → 8 Marks",
  "10 Recorded Classes",
  "6 LIVE Classes",
  "Modules & Notes",
  "UPSC Topper Level",
];

const EditorialMarquee = () => (
  <section
    data-testid="marquee-strip"
    className="bg-[#0a0a0a] py-6 md:py-8 overflow-hidden"
  >
    <Marquee speed={40} gradient={false} className="marquee-mask">
      {items.map((it, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display font-extrabold text-3xl md:text-5xl text-white tracking-tight px-8">
            {it}
          </span>
          <span className="text-[#58cc02] text-3xl md:text-5xl">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
